import { Card, Spacer, Switch, SwitchProps, Text } from '@sparemin/blockhead';
import React from 'react';
import { Blur } from 'components/icons';
import { block } from './utils';

export type BlurToggleProps = Pick<SwitchProps, 'isDisabled' | 'onChange'> & {
  label?: string;
  isActive: boolean;
  isDisabled?: boolean;
};

const BlurToggle: React.FC<BlurToggleProps> = ({
  label = 'Background blur',
  isActive,
  isDisabled,
  onChange,
}) => (
  <Card className={block()} header={<></>} footer={<></>}>
    <Switch
      id="blur-toggle-switch"
      isSelected={isActive}
      isDisabled={isDisabled}
      labelPosition="before"
      className={block('toggle')}
      onChange={onChange}
    >
      <Spacer
        align="center"
        className={block('contents')}
        justify="center"
        orientation="horizontal"
        space="10px"
      >
        <Blur />
        <Text className={block('label')} variant="label">
          {label}
        </Text>
      </Spacer>
    </Switch>
  </Card>
);

export default BlurToggle;
